module.exports = __webpack_public_path__ + "static/media/soroush-karimi.74f5520f.jpg";